import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "card card-feat" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "border-bottom border-light py-2 mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 pt-3" }, "När du väljer ett bud", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " När du väljer ett av lånen så stängs möjligheten att få fler lånealternativ från andra banker. Därför rekommenderar vi att du väntar 24 timmar så att du hinner få svar från samtliga banker - bortse från helgdagar då inte alla banker har öppet. ")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "account-info-form-font" }, " Här nedan anger du det konto som pengarna ska bli utbetalda till: ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  id: "collapse-konto",
  class: "collapse"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "offer-panel" }, "Inkluderar både ränta och amortering")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Ett fel uppstod när du valde låneerbjudandet. Var god försök igen eller")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" kontaktavår kundjänst på tel. 020-25 26 26 så hjälper vi dig gärna. ")
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "mt-1" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Alla fält är obligatoriska, var god kontrollera att du har valt en bank,")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" kontrollera att clearingnumret och bankkontonumret är korrekta. ")
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, null, -1)
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Välj ")
const _hoisted_25 = { class: "border-top border-light mt-3 pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_AccountInfoForm = _resolveComponent("AccountInfoForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _createVNode(_component_BackButton),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("div", null, _hoisted_7, 512), [
            [_vShow, _ctx.loanStatus === 1 || _ctx.loanStatus === 3 || _ctx.loanStatus === 4]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_CheckboxInput, {
            label: "Jag har läst ovan och vill få lånehandlingarna skickade till mig",
            modelValue: _ctx.agreeTerms,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agreeTerms) = $event)),
            error: 
              _ctx.agreeTerms || !_ctx.isLoading
                ? ''
                : 'Du måste klicka för att du godkänner våra allmänna villkor.'
            
          }, null, 8, ["modelValue", "error"])
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _hoisted_9,
          _hoisted_10,
          _createVNode(_component_AccountInfoForm, {
            onUpdate: _cache[1] || (_cache[1] = (value) => (_ctx.selectOfferForm.account = { ...value })),
            tooltips: true
          })
        ], 512), [
          [_vShow, _ctx.agreeTerms && _ctx.offer.bank.showAccountDetailsForPayment]
        ]),
        _createElementVNode("div", null, [
          (_ctx.offerSelectingError && _ctx.agreeTerms)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          (!_ctx.isValid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_21))
            : _createCommentVNode("", true),
          _hoisted_22,
          (_ctx.agreeTerms)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                type: "button",
                class: "btn btn-primary btn-lg btn-block primary-button mt-3",
                disabled: _ctx.isLoading
              }, [
                _hoisted_24,
                _createElementVNode("span", null, _toDisplayString(_ctx.offer.bank.name), 1)
              ], 8, _hoisted_23))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_BackButton)
        ])
      ])
    ])
  ]))
}